<template>
  <div class="wrapper">
    <lastpage></lastpage>
    <ul class="timeSel">
      <li v-for="(item,index) in date" :key="index" @click="handleTab(index,item)" :class="current == index?`list_xuan`:` `">
        <span>{{ item.week }}</span>
        <span>{{ item.day }}</span>
        <span :class="current == index?`selectTriangle`:` `"></span>
      </li>
    </ul>
    <ul v-if="doctorList.length != 0" class="doctorSel">
      <li v-for="item in doctorList" :key="item.DoctorId">
        <img src="@/assets/appointment/doctor_icon.png">
        <div>
          <p class="doctor_name">
            <span>{{ item.DoctorName }}</span>
            <span>{{ item.LabelName }}</span>
          </p>
          <p style="margin: 5px 0px">剩余号源：{{ item.RegRemained }}个</p>
          <!-- <p style="padding: 5px 0px"></p> -->
          <foldText :showContent="item.Description == ''?'信息正在录入中...':item.Description"></foldText>
        </div>
        <span class="yybtn_cl" @click="makebtn(item)">
          预约挂号
        </span>
      </li>
      <!-- <li>
        <img src="@/assets/appointment/doctor_icon.png">
        <div>
          <p class="doctor_name">
            <span>邱陆军</span>
            <span>副主任医师</span>
          </p>
          <p style="margin: 5px 0px">剩余号源：25个</p>
          <foldText :showContent="emmm"></foldText>
        </div>
        <span class="yybtn_cl" @click="makebtn">
          预约挂号
        </span>
      </li> -->
    </ul>
    <div v-if="doctorList.length == 0" class="null_doctor">
      当前日期暂无值班医生
    </div>
  </div>
</template>

<script>
import foldText from "@/components/foldText/foldText";
import { getOuDeptSchedules } from "@/request/api.js";
import lastpage from "@/components/lastpage/lastpage.vue";
export default {
  components: {
    foldText,
    lastpage
  },
  data() {
    return {
      current: 0,
      date: [],
      nowdate: null,
      year: null,
      doctorList: [],
      emmm:"xiao",
      time: ""
    };
  },
  created() {
    // this.getDate();
    // this.getregister();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm就是this
      // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例 ; vm就相当于this!!!!
      // vm.formUrl = from.path;
      if(vm.date.length == 0){
        vm.date = [];
        vm.getDate();
      }
      if(from.path == "/DepartmentSelection"){
        vm.date = [];
        vm.getDate();
        vm.current= 0;
        vm.nowdate = vm.date[0].day;
        sessionStorage.setItem("current",vm.current);
        vm.getregister();
      } else {
        vm.getregister();
      }
    })
  },
  // activated() {
  //   this.getregister();
  // },
  methods: {
    // 获取时间
    getDate(){
      this.year = this.$moment().format('YYYY')
      for(let i=0;i<7;i++){
        let str = this.$moment().add(i,'days').format('dddd,M.DD');
        let ary = str.split(",");
        let wk = "";
        switch (ary[0]) {
          case "Monday":
            wk = '周一'
            break;
          case "Tuesday":
            wk = '周二'
            break;
          case "Wednesday":
            wk = '周三'
            break;
          case "Thursday":
            wk = '周四'
            break;
          case "Friday":
            wk = '周五'
            break;
          case "Saturday":
            wk = '周六'
            break;
          case "Sunday":
            wk = '周日'
            break;
          default:
            break;
        }
        if(i==0){
          this.date.push({week: '今天',day: ary[1]})
        } else {
          this.date.push({week: wk,day: ary[1]})
        }
      }
      if(!this.nowdate){
        this.nowdate = this.date[0].day
      }
    },
    // 获取可挂号医生
    async getregister(){
      this.time = (this.year+"."+this.nowdate).replace(/\./g, "-");
      sessionStorage.setItem("clinicDate",this.time);
      let map = {
        clinicDate: this.$moment(this.time.replace(/\-/g, "/")).format('YYYY-MM-DD'),
        deptID: sessionStorage.getItem('DeptID'),
        hspCode: sessionStorage.getItem("hspCode"),
        userId: "7148"
      }
      let res = await getOuDeptSchedules(map)
      if(res.data.message == "操作成功"){
        this.doctorList = res.data.obj.resultData
      } else {
        this.doctorList = []
      }
    },
    handleTab(value,item){
      this.current = value;
      this.nowdate = item.day;
      this.getregister();
    },
    makebtn(item){
      sessionStorage.setItem("current",this.current);
      sessionStorage.setItem('doctorInfo',JSON.stringify(item));
      this.$router.push("/ChooseTime");
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F8F8F8;
  .timeSel{
    display: flex;
    flex-flow: row nowrap;
    // margin-top: 10px;
    background: #fff;
    height: 78px;
    font-size: 15px;
    >li{
      position: relative;
      flex: 1;
      display: flex;
      flex-flow: column nowrap;
      text-align: center;
      height: 100%;
      justify-content: center;
      >span:nth-child(1){
        margin-bottom: 13px;
      }
      .selectTriangle{
        transition: all .6s;
        position: absolute;
        width: 32px;
        height: 5px;
        left: calc(50% - 16px);
        bottom: 2px;
        background: #1C96CB;
        border-radius: 3px;
        margin: 0px !important;
      }
    }
    .list_xuan{
      transition: all .6s;
      color: #1C96CB;
    }
  }
  .doctorSel{
    display: flex;
    flex-flow: column nowrap;
    margin: 10px;
    >li{
      position: relative;
      margin-bottom: 10px;
      padding: 10px;
      background: #fff;
      display: flex;
      flex-flow: row;
      flex-flow: row nowrap;
      >img{
        width: 54px;
        height: 66px;
      }
      >div{
        margin: 0px 40px 0px 15px;
        color: #AEAEAE;
        font-size: 12px;
        flex: 1;
        .doctor_name{
          >span:nth-child(1){
            font-size: 18px;
            font-weight: bold;
            color: #000;
            margin-right: 2px;
          }
        }
        >p:nth-child(3){
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          >img{
            width: 18px;
            position: absolute;
            bottom: 10px;
            right: 30px;
          }
        }
      }
      .yybtn_cl{
        position: absolute;
        top: 13px;
        right: 13px;
        background: #1C96CB;
        padding: 7px 13px;
        font-size: 13px;
        color: #fff;
        border-radius: 19px;
      }
    }
  }
  .null_doctor{
    text-align: center;
    padding: 60px 0px;
    font-size: 20px;
    font-weight: bold;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/ChooseDoctor.vue